import { Component } from '@angular/core';
import { ModalBase } from '../../base/modal-base/modal-base.component';

@Component({
    selector: 'ask-share-us-form-modal',
    templateUrl: 'ask-share-us-form.modal.html',
    standalone: false,
})
export class AskShareUsFormModal extends ModalBase {
    public get modalId(): string {
        return 'ask-share-us-form-modal';
    }

    public openModal(): void {
        this.open();
    }

    public ngAfterViewInit(): void {
        this.init();
    }
}
